function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

function toCssLength(value) {
  return typeof value === "number" ? `${value}px` : value;
}

function composeStickyTop(stackedHeights, offset) {
  const parts = [
    "var(--lz-v2-sticky-offset-base)",
    ...stackedHeights.map(toCssLength).filter(Boolean),
  ];
  const resolvedOffset = toCssLength(offset);
  if (resolvedOffset && resolvedOffset !== "0px" && resolvedOffset !== "0") {
    parts.push(resolvedOffset);
  }
  return parts.length === 1 ? parts[0] : `calc(${parts.join(" + ")})`;
}

export default function StickyPageHeader({
  as: Component = "header",
  stackedHeights = [],
  offset = 0,
  className = "",
  style,
  children,
  ...props
}) {
  return (
    <Component
      {...props}
      className={joinClassNames("lz-v2-sticky-page-header", className)}
      style={{
        ...style,
        "--lz-v2-sticky-page-header-top": composeStickyTop(stackedHeights, offset),
      }}
    >
      {children}
    </Component>
  );
}
